const supportedImageTypes = ['jpg', 'jpeg', 'png', 'apng', 'gif', 'webp', 'svg', 'avif']
const supportedPdfTypes = ['pdf']

export enum FileViewerType {
    IMAGE = 'image',
    PDF = 'pdf',
    UNSUPPORTED = 'unsupported'
}

export const getFileViewerTypeFromURL = (url: string): FileViewerType | undefined=> {

    const fileType = getFileTypeFromUrl(url)

    if (!fileType) {
        return undefined
    }
    if (supportedImageTypes.includes(fileType)) {
        return FileViewerType.IMAGE
    }
    if (supportedPdfTypes.includes(fileType)) {
        return FileViewerType.PDF
    }
    return FileViewerType.UNSUPPORTED
}


function getFileTypeFromUrl(urlString: string): string | undefined {

    if (!urlString) {
        return undefined
    }

    let url: URL
    try {
        url = new URL(urlString)
    } catch (e) {
        return undefined
    }

    const pathname = url.pathname

    const pathSegments = pathname.split('/')
    const fullFilename = pathSegments[pathSegments.length - 1]

    if (!fullFilename) {
        return undefined
    }

    const lastDotIndex = fullFilename.lastIndexOf('.')

    if (lastDotIndex === -1 || lastDotIndex === fullFilename.length - 1) {
        return undefined
    }

    const fileExtension = fullFilename.substring(lastDotIndex + 1).toLowerCase()

    return fileExtension
}